export const events = [
  {
    year: '2026',
    items: [
      {
        id: 1,
        dateString: '06 a 08 de Janeiro',
        startDate: '2026-01-06',
        endDate: '2026-01-08',
        title: 'Pós Reveillon',
        description: 'Continue a celebração de um novo ano com nosso pacote especial de Pós Reveillon. Aproveite o ápice do verão com muita alegria, conforto e descanso merecido.',
        category: 'Celebração',
        icon: 'FaGlassCheers',
        image: '/images/ProgramsSection/PosReveillon/posreveillon.webp',
        details: { imagens: [] }
      },
      {
        id: 2,
        dateString: '13 a 18 de Fevereiro',
        startDate: '2026-02-13',
        endDate: '2026-02-18',
        title: 'Carnaval',
        description: 'Celebre o Carnaval com a verdadeira alegria de São Lourenço! Desfrute de muita marchinha, conforto e viva a experiência exclusiva de desfilar pelas ruas da cidade no nosso tradicional Bloco dos Hotéis Alzira. Diversão e folia garantidas para toda a família!',
        category: 'Celebração',
        icon: 'FaMusic',
        image: '/images/ProgramsSection/Carnaval/carnaval001.webp',
        details: { imagens: [
          '/images/ProgramsSection/Carnaval/carnaval002.webp',
          '/images/ProgramsSection/Carnaval/carnaval003.webp',
          '/images/ProgramsSection/Carnaval/carnaval004.webp',
          '/images/ProgramsSection/Carnaval/carnaval005.webp',
          '/images/ProgramsSection/Carnaval/carnaval001.webp',
        ] }
      },
      {
        id: 3,
        dateString: 'Finais de Semana (Fevereiro e Março)',
        startDate: '2026-02-01',
        endDate: '2026-03-31',
        title: 'Festa Cigana',
        description: 'Misticismo, dança, cores vibrantes e muita alegria! Nossos finais de semana de fevereiro e março ganham vida com a tradicional e imersiva Festa Cigana.',
        category: 'Cultura',
        icon: 'FaMusic',
        image: '/images/ProgramsSection/Cigana/cigano009.webp',
        details: { imagens: ['/images/ProgramsSection/Cigana/cigano008.webp',
          '/images/ProgramsSection/Cigana/cigano002.webp',
          '/images/ProgramsSection/Cigana/cigano003.webp',
          '/images/ProgramsSection/Cigana/cigano001.webp',
          '/images/ProgramsSection/Cigana/cigano006.webp',
          '/images/ProgramsSection/Cigana/cigano007.webp',
          '/images/ProgramsSection/Cigana/cigano008.webp',
          '/images/ProgramsSection/Cigana/cigano010.webp',
          '/images/ProgramsSection/Cigana/cigano005.webp',
          '/images/ProgramsSection/Cigana/cigano004.webp',
          '/images/ProgramsSection/Cigana/cigano009.webp',
        ] }
      },
      {
        id: 4,
        dateString: 'Finais de Semana (Abril)',
        startDate: '2026-04-01',
        endDate: '2026-04-30',
        title: 'Festival do Torresmo',
        description: 'O melhor da culinária mineira em destaque! Venha saborear o nosso incrível Festival do Torresmo durante os finais de semana de abril. Crocância e sabor inesquecíveis.',
        category: 'Gastronomia',
        icon: 'FaUtensils',
        image: '/images/ProgramsSection/Torresmo/torresmo001.webp',
        details: { imagens: [
          '/images/ProgramsSection/Torresmo/torresmo002.webp',
          '/images/ProgramsSection/Torresmo/torresmo003.webp',
          '/images/ProgramsSection/Torresmo/torresmo004.webp',
          '/images/ProgramsSection/Torresmo/torresmo005.webp',
          '/images/ProgramsSection/Torresmo/torresmo006.webp',
          '/images/ProgramsSection/Torresmo/torresmo001.webp',
        ] }
      },
      {
        id: 5,
        dateString: '08 a 10 de Maio',
        startDate: '2026-05-08',
        endDate: '2026-05-10',
        title: 'Especial Dia das Mães: Alexandre Arez',
        description: 'Emocione quem você mais ama neste Dia das Mães com um show exclusivo do cantor Alexandre Arez, regado a muito romantismo, alta gastronomia e conforto absoluto.',
        category: 'Música',
        icon: 'FaMusic',
        image: '/images/ProgramsSection/AlexandreArez/alexandre.webp',
        details: { imagens: [] }
      },
      {
        id: 6,
        dateString: 'Maio a Setembro',
        startDate: '2026-05-01',
        endDate: '2026-09-30',
        title: 'Festa Junina',
        description: 'Viva a magia de uma autêntica Festa Junina! Em noites aquecidas pelo calor da fogueira e pelo sabor do quentão, celebre a tradição com o melhor da culinária típica, quadrilha animada e música ao vivo.',
        category: 'Cultura',
        icon: 'FaMusic',
        image: '/images/ProgramsSection/FestaJunina/junina001.webp',
        details: {
          imagens: [
            '/images/ProgramsSection/FestaJunina/junina002.webp',
            '/images/ProgramsSection/FestaJunina/junina003.webp',
            '/images/ProgramsSection/FestaJunina/junina004.webp',
            '/images/ProgramsSection/FestaJunina/junina005.webp',
            '/images/ProgramsSection/FestaJunina/junina006.webp',
            '/images/ProgramsSection/FestaJunina/junina007.webp',
            '/images/ProgramsSection/FestaJunina/junina008.webp',
            '/images/ProgramsSection/FestaJunina/junina009.webp',
            '/images/ProgramsSection/FestaJunina/junina010.webp',
            '/images/ProgramsSection/FestaJunina/junina011.webp',
            '/images/ProgramsSection/FestaJunina/junina012.webp',
            '/images/ProgramsSection/FestaJunina/junina014.webp',
            '/images/ProgramsSection/FestaJunina/junina015.webp',
            '/images/ProgramsSection/FestaJunina/junina001.webp',
          ]
        }
      },
      {
        id: 7,
        dateString: '06 a 09 de Julho',
        startDate: '2026-07-06',
        endDate: '2026-07-09',
        title: 'Show com Gilliard',
        description: 'Uma noite inesquecível embalada pelos grandes sucessos românticos na voz inconfundível do cantor Gilliard.',
        category: 'Música',
        icon: 'FaMusic',
        image: '/images/ProgramsSection/Gilliard/gilliard.webp',
        details: { imagens: [] }
      },
      {
        id: 8,
        dateString: '28 de Set a 01 de Out',
        startDate: '2026-09-28',
        endDate: '2026-10-01',
        title: 'Show com Elymar Santos',
        description: 'Elymar Santos, um dos maiores showmans do Brasil, sobe ao nosso palco para uma noite inesquecível, repleta de carisma e seus maiores sucessos.',
        category: 'Música',
        icon: 'FaMusic',
        image: '/images/ProgramsSection/Elymar/elymar1.webp',
        details: { imagens: ['/images/ProgramsSection/Elymar/elymar006.webp',
          '/images/ProgramsSection/Elymar/elymar005.webp',
          '/images/ProgramsSection/Elymar/elymar004.webp',
          '/images/ProgramsSection/Elymar/elymar003.webp',
          '/images/ProgramsSection/Elymar/elymar002.webp',
          '/images/ProgramsSection/Elymar/elymar001.webp',
        ] }
      },
      {
        id: 9,
        dateString: '06 a 08 de Novembro',
        startDate: '2026-11-06',
        endDate: '2026-11-08',
        title: 'Show com Altemar Dutra Jr',
        description: 'Uma noite para celebrar o amor e a música romântica. Altemar Dutra Jr nos presenteia com sua voz marcante em um espetáculo intimista.',
        category: 'Música',
        icon: 'FaMusic',
        image: '/images/ProgramsSection/Altemar/altemar.webp',
        details: { imagens: [] }
      },
      {
        id: 10,
        dateString: 'Dezembro',
        startDate: '2026-12-01',
        endDate: '2026-12-22',
        title: 'Boi no Rolete',
        description: 'Prepare-se para um verdadeiro espetáculo gastronômico. Nosso Boi no Rolete é assado lentamente por horas, garantindo uma carne macia e extremamente saborosa.',
        category: 'Gastronomia',
        icon: 'FaUtensils',
        image: '/images/ProgramsSection/BoiNoRolete/boi000.webp',
        details: { imagens: [
          '/images/ProgramsSection/BoiNoRolete/boi001.webp',
          '/images/ProgramsSection/BoiNoRolete/boi002.webp',
          '/images/ProgramsSection/BoiNoRolete/boi003.webp',
          '/images/ProgramsSection/BoiNoRolete/boi004.webp',
          '/images/ProgramsSection/BoiNoRolete/boi005.webp',
          '/images/ProgramsSection/BoiNoRolete/boi000.webp',
        ] }
      },
      {
        id: 11,
        dateString: '23 a 26 de Dezembro',
        startDate: '2026-12-23',
        endDate: '2026-12-26',
        title: 'Natal',
        description: 'Deixe a magia do Natal envolver você e sua família. Com uma decoração deslumbrante, ceia especial farta e a presença do Papai Noel para a alegria das crianças.',
        category: 'Celebração',
        icon: 'FaTree',
        image: '/images/ProgramsSection/Natal/natal001.webp',
        details: { imagens: [
          '/images/ProgramsSection/Natal/natal003.webp',
          '/images/ProgramsSection/Natal/natal004.webp',
          '/images/ProgramsSection/Natal/natal005.webp',
          '/images/ProgramsSection/Natal/natal006.webp',
          '/images/ProgramsSection/Natal/natal007.webp',
          '/images/ProgramsSection/Natal/natal008.webp',
          '/images/ProgramsSection/Natal/natal009.webp',
          '/images/ProgramsSection/Natal/natal010.webp',
          '/images/ProgramsSection/Natal/natal011.webp',
          '/images/ProgramsSection/Natal/natal002.webp',
        ] }
      },
      {
        id: 12,
        dateString: '29 Dez a 01 Jan',
        startDate: '2026-12-29',
        endDate: '2027-01-01',
        title: 'Reveillon',
        description: 'Dê as boas-vindas ao novo ano em grande estilo. Nossa festa de Reveillon é uma celebração de gala com ceia premium, espumante, música ao vivo e muita comemoração.',
        category: 'Celebração',
        icon: 'FaGlassCheers',
        image: '/images/ProgramsSection/Reveillon/reveillon001.webp',
        details: { imagens: [
          '/images/ProgramsSection/Reveillon/reveillon002.webp',
          '/images/ProgramsSection/Reveillon/reveillon003.webp',
          '/images/ProgramsSection/Reveillon/reveillon004.webp',
          '/images/ProgramsSection/Reveillon/reveillon005.webp',
          '/images/ProgramsSection/Reveillon/reveillon006.webp',
          '/images/ProgramsSection/Reveillon/reveillon007.webp',
          '/images/ProgramsSection/Reveillon/reveillon008.webp',
          '/images/ProgramsSection/Reveillon/reveillon009.webp',
          '/images/ProgramsSection/Reveillon/reveillon010.webp',
          '/images/ProgramsSection/Reveillon/reveillon011.webp',
          '/images/ProgramsSection/Reveillon/reveillon012.webp',
          '/images/ProgramsSection/Reveillon/reveillon013.webp',
          '/images/ProgramsSection/Reveillon/reveillon014.webp',
          '/images/ProgramsSection/Reveillon/reveillon015.webp',
          '/images/ProgramsSection/Reveillon/reveillon016.webp',
          '/images/ProgramsSection/Reveillon/reveillon001.webp',
        ] }
      }
    ]
  },
  {
    year: '2027',
    items: [
      {
        id: 13,
        dateString: '05 a 07 de Janeiro',
        startDate: '2027-01-05',
        endDate: '2027-01-07',
        title: 'Pós Reveillon',
        description: 'Continue a celebração de um novo ano com nosso pacote especial de Pós Reveillon. Aproveite o ápice do verão com muita alegria, conforto e descanso merecido.',
        category: 'Celebração',
        icon: 'FaGlassCheers',
        image: '/images/ProgramsSection/PosReveillon/posreveillon008.webp',
        details: { imagens: [
          '/images/ProgramsSection/PosReveillon/posreveillon002.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon003.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon004.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon006.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon007.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon009.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon010.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon011.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon012.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon013.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon014.webp',
          '/images/ProgramsSection/PosReveillon/posreveillon008.webp',
        ] }
      },
      {
        id: 14,
        dateString: '05 a 10 de Fevereiro',
        startDate: '2027-02-05',
        endDate: '2027-02-10',
        title: 'Carnaval',
        description: 'Celebre o Carnaval com a verdadeira alegria de São Lourenço! Desfrute de muita marchinha, conforto e viva a experiência exclusiva de desfilar pelas ruas da cidade no nosso tradicional Bloco dos Hotéis Alzira. Diversão e folia garantidas para toda a família!',
        category: 'Celebração',
        icon: 'FaMusic',
        image: '/images/ProgramsSection/Carnaval/carnaval001.webp',
        details: { imagens: [
          '/images/ProgramsSection/Carnaval/carnaval002.webp',
          '/images/ProgramsSection/Carnaval/carnaval003.webp',
          '/images/ProgramsSection/Carnaval/carnaval004.webp',
          '/images/ProgramsSection/Carnaval/carnaval005.webp',
          '/images/ProgramsSection/Carnaval/carnaval001.webp',
        ] }
      }
    ]
  }
];